export { default as CartIcon } from './ic__cart.svg';
export { default as Text택배배송Icon } from './ic__delivery-courier.svg';
export { default as SafeDeliveryIcon } from './safe_delivery.svg';
export { default as SafeDeliveryWithTextIcon } from './safe_delivery_with_text.svg';
